export const TripTypes = {
  Ski: "Ski",
  SkiInspection: "SkiInspection",
  EducationalTour: "EducationalTour",
  EducationalTourInspection: "EducationalTourInspection",
};

export const RepInfoSteps = {
  Personal: "personal",
  Passport: "passport",
  Medical: "medical",
  Additional: "additional",
  Submit: "submit",
};

// must be in sync with the c# enum of the same name
export const PassengerPortalStatus = {
  Incomplete: "Incomplete",
  Completed: "Completed",
  Cancelled: "Cancelled",
  Submitted: "Submitted",
};

export const enumOptionsArray = (enumObj) => {
  return Object.keys(enumObj).map((k) => ({ value: k, text: enumObj[k] }));
};

export const SkierTypes = {
  NonSkier: "NonSkier",
  Snowboarder: "Snowboarder",
  Skier: "Skier",
};

export const SkiAbilityExtraInfoMap = {
  AbsoluteBeginner:
    "First time: may have had an introductory session to the sport",
  LowerIntermediate:
    "Usually 1-2 weeks experience with the ability to link turns on beginner terrain",
  HigherIntermediate:
    "Linking turns and ability to control speed on more blue and red runs",
  AdvancedSkierOrRider:
    "Confident getting down any marked pistes on the mountain",
};

export const PassengerTypes = {
  Adult: "Adult",
  Pupil: "Pupil",
  Infant: "Infant",
};

export const OwnSkiEquipment = {
  OwnSkiBoots: "OwnSkiBoots",
  OwnSkis: "OwnSkis",
  OwnSkisAndBoots: "OwnSkisAndBoots",
  OwnSnowboardBoots: "OwnSnowboardBoots",
  OwnSnowboard: "OwnSnowboard",
  OwnSnowboardAndBoots: "OwnSnowboardAndBoots",
  NonSkier: "NonSkier",
};

export const PassengerTabs = {
  KeyInfo: "KeyInfo",
  Apis: "Apis",
  Ski: "Ski",
  Diet: "Diet",
  Additional: "Additional",
};

export const ContactPointTypes = {
  MainPhone: 0,
  Mobile: 1,
  Email: 2,
  Fax: 3,
  Skype: 4,
  EmergencyPhone: 5,
  DirectPhone: 6,
  Website: 7,
};

//SubCategories
export const TravelTypes = {
  Flights: 0,
  Exclude: 1,
  UkTouringCoach: 2,
  ChannelCrossing: 3,
  Discount: 4,
  Equipment: 5,
  EveningActivityExcursion: 6,
  Accommodation: 10,
  Insurance: 11,
  LiftPass: 12,
  ResortRep: 14,
  Supplement: 15,
  Tuition: 18,
  UkCoachTransfer: 20,
  AgentPackage: 24,
  OverseasCoach: 25,
  AirPassengerDuty: 27,
  Atol: 30,
  Gift: 31,
  Meal: 32,
};

export const ResortRepItineraryType = {
  Travel: 0,
  Accommodation: 1,
};
